import { SxProps } from '@mui/material/styles';
import { Theme } from '@mui/system';
import { typography } from 'theme/typography';
import { pxToRem } from '../utils/fonts';

export const alertSx: SxProps<Theme> = {
  width: '100%',
  p: 12,
  '& .MuiAlert-action': {
    py: 0,
    marginTop: pxToRem(2),
  },
  '& .MuiAlert-action .MuiIconButton-root': { py: 0 },
  '& .MuiAlert-icon': {
    ...typography.h4,
    height: pxToRem(20),
    py: 0,
    fontSize: pxToRem(20),
    lineHeight: 1,
    my: pxToRem(4),
  },
  '& .MuiAlert-message': {
    ...typography.h4,
    p: 0,
    marginTop: pxToRem(4),
    marginLeft: pxToRem(12),

    '&::-webkit-scrollbar': {
      visibility: 'hidden',
    },
  },
};
